// Este componente ahora importa los datos del blog desde features/blog/blogData.js
// siguiendo la arquitectura modular basada en features para mejor mantenimiento.
import React, { useEffect } from "react";
import "../pages/blog.css";
import temas from "../features/blog/blogData";

export default function Blog() {
  useEffect(() => {
    const resizeMasonry = () => {
      document.querySelectorAll(".tema-masonry").forEach((masonry) => {
        const rowHeight = parseInt(window.getComputedStyle(masonry).getPropertyValue("grid-auto-rows"));
        const rowGap = parseInt(window.getComputedStyle(masonry).getPropertyValue("gap"));

        masonry.querySelectorAll(".blog-card").forEach((card) => {
          const img = card.querySelector("img");
          const overlay = card.querySelector(".overlay");
          const cardHeight = img.getBoundingClientRect().height + overlay.getBoundingClientRect().height;
          const rowSpan = Math.ceil((cardHeight + rowGap) / (rowHeight + rowGap));
          card.style.gridRowEnd = `span ${rowSpan}`;
        });
      });
    };

    // Ejecuta después de que todas las imágenes carguen
    const images = document.querySelectorAll(".tema-masonry img");
    let loadedCount = 0;

    images.forEach((img) => {
      if (img.complete) loadedCount++;
      else img.addEventListener("load", () => {
        loadedCount++;
        if (loadedCount === images.length) resizeMasonry();
      });
    });

    if (loadedCount === images.length) resizeMasonry();

    window.addEventListener("resize", resizeMasonry);
    return () => window.removeEventListener("resize", resizeMasonry);
  }, []);

  return (
    <section className="blog">
      <h1>Blog: Motivación, Nutrición y Rutinas</h1>

      {temas.map((tema) => (
        <div key={tema.id} className={`tema-blog tema-${tema.id}`}>
          <header className="tema-header">
            <h2>{tema.titulo}</h2>
            <p>{tema.descripcion}</p>
          </header>

          <div className="tema-masonry">
            {tema.posts.map((post, i) => (
              <div key={i} className="blog-card">
                <img src={post.img} alt={post.title} />
                <div className="overlay">
                  <h3>{post.title}</h3>
                  <p>{post.excerpt}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </section>
  );
}
